<template>
  <div :class="$style.chart">
    <canvas ref="chartEl"> </canvas>
  </div>
</template>
<script>
import {
  Chart,
  PolarAreaController,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { calcPercentage } from "/@/utils";

Chart.register(
  PolarAreaController,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Filler,
  Legend
);

let chart;
export default {
  props: {
    mod: Object,
  },
  computed: {
    labels() {
      return this.mod.secondaryStat.map(({ name }) => name);
    },
    values() {
      return this.mod.secondaryStat.map((stat) =>
        (calcPercentage(stat, this.mod.pips) * 100).toFixed(2)
      );
    },
    name() {
      return this.mod.set_name + " mod";
    },
  },
  watch: {
    mod() {
      chart.data.labels = [...this.labels];
      chart.data.datasets[0].label = this.name;
      chart.data.datasets[0].data = [...this.values];
      chart.update();
    },
  },
  mounted() {
    chart = new Chart(this.$refs.chartEl, {
      type: "polarArea",
      data: {
        labels: [...this.labels],
        datasets: [
          {
            label: this.name,
            data: [...this.values],
            borderColor: "hsl(224.2, 33.3%, 88.8%)",
            backgroundColor: [
              "#ffffff50",
              "#ff33ff50",
              "#ffff3350",
              "#33ffff50",
            ],
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          r: {
            max: 100,
            pointLabels: {
              fontColor: "aquamarine",
              fontSize: "16",
            },
            angleLines: {
              lineWidth: 3,
            },
            gridLines: {
              circular: true,
              lineWidth: 3,
            },
            ticks: {
              min: 0,
              max: 100,
            },
          },
        },
        color: "yellow",
      },
    });
  },
};
</script>
<style module>
canvas {
  background-color: steelblue;
}

.chart {
  --size: min(60vh, 75vw);
  width: var(--size);
  height: var(--size);
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
</style>
